<div class="container">
  <cdk-virtual-scroll-viewport itemSize="500" minBufferPx="1000" maxBufferPx="2000">
    <app-title [back]="false">{{titleText}}</app-title>
    <ng-container *ngIf="activities?.length">
      <app-activity-timeline-card *cdkVirtualFor="let activity of activities" [activity]="activity"></app-activity-timeline-card>
    </ng-container>
  </cdk-virtual-scroll-viewport>
</div>
<a mat-fab class="add-button" routerLink="/accounts/new">
  <mat-icon aria-label="Add">add</mat-icon>
</a>